import {Component, Input, Output, EventEmitter} from '@angular/core';

@Component({
    selector: 'image-uploader',
    templateUrl: './image-uploader.component.html',
    styleUrls: ['./image-uploader.component.scss'],
    inputs: ['activeColor', 'baseColor', 'overlayColor'],
    standalone: false
})
export class ImageUploaderComponent {

    iconColor: string;

    borderColor: string;
    activeColor: string = 'green';
    baseColor: string = '#ccc';
    overlayColor: string = 'rgba(255,255,255,0.5)';

    dragging: boolean = false;
    loaded: boolean = false;
    imageLoaded: boolean = false;
    imageSrc: string = '';

    fullImageUrl;
    @Input() set imageUrl(url){
        console.log('setimageUrl:'+url);
        if(url) {
            this.fullImageUrl = url+'?timestamp='+new Date().getTime()
        }
    };

    @Input() maxFileSizeMb = 1;
    @Input() progress;
    @Output() fileUpdated = new EventEmitter();

    fileName: string;
    fileType: string;
    fileSize: number;

    @Input() multiple = false;

    handleDragEnter() {
        this.dragging = true;
    }

    handleDragLeave() {
        this.dragging = false;
    }

    handleDrop(e) {
        e.preventDefault();
        this.dragging = false;
        this.handleInputChange(e);
    }

    handleImageLoad() {
      console.log('handleImageLoad');
        this.imageLoaded = true;
        this.iconColor = this.overlayColor;
    }

    handleInputChange(e) {
        var fileLength = e.dataTransfer ? e.dataTransfer.files.length : e.target.files.length;
        console.log('Loading file - fileLength:'+fileLength);
        for (var i = 0; i < fileLength; i++) {
            var file = e.dataTransfer ? e.dataTransfer.files[i] : e.target.files[i];
            console.log('handleInputChange');
            var pattern = /image-*/;
            var reader = new FileReader();

            this.fileName = file.name;
            this.fileType = file.type;
            if(!file.type)
            this.fileType = 'unknown';
            this.fileSize = file.size;
            if (!file.type.match(pattern)) {
                alert('invalid format');
                return;
            }

            if (this.fileSize>(this.maxFileSizeMb*1024*1024)) {
                alert('Logo image is too big. Maximum allowed is '+this.maxFileSizeMb);
                return;
            }

            this.loaded = false;
            console.log('File name is:'+file.name);
            reader.onload = this._handleReaderLoaded.bind(this);
            reader.readAsDataURL(file);
        }
    }

    _handleReaderLoaded(e) {
        var reader = e.target;
        //console.log('_handleReaderLoaded:'+reader.result);
        this.fullImageUrl = reader.result;
        //console.log('this.document.data:'+this.fullImageUrl);
        this.loaded = true;
        this.fileUpdated.emit(this.fullImageUrl);
    }

    _setActive() {
        this.borderColor = this.activeColor;
        if (this.imageSrc.length === 0) {
            this.iconColor = this.activeColor;
        }
    }

    _setInactive() {
        this.borderColor = this.baseColor;
        if (this.imageSrc.length === 0) {
            this.iconColor = this.baseColor;
        }
    }

}
